var $347a4a6b5e1d25ae$exports = {};
$347a4a6b5e1d25ae$exports = {
    "close": `Sule`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} teatis`,
            other: ()=>`${formatter.number(args.count)} teatist`
        })}.`
};


export {$347a4a6b5e1d25ae$exports as default};
//# sourceMappingURL=et-EE.mjs.map
